import { Link } from "react-router-dom";

export default function NotFoundView() {
  return (
    <div>
      <h2>{"요청하신 페이지를 찾을 수 없습니다. (404 Not Found)"}</h2>
      <div>
        <Link to={'..'} >돌아가기</Link>
      </div>
    </div>
  );

}